import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParkingCardInfo } from '../../../../../../../core/models/information.model';
import { MyVehicleAllForChange } from '../../../../../../../core/models/user.model';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { PssLoadingComponent } from '../../../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { ApiVehicleService } from '../../../../../../../core/services/api/Vehicle/api-vehicle';
import { MyVehicleSelectPayload } from '../../../../../../../core/models/my-member-card/my-vehicle-select.model';

@Component({
  selector: 'app-my-vehicle-select',
  standalone: true,
  imports: [CommonModule, PssLoadingComponent],
  templateUrl: './my-vehicle-select.component.html',
  styleUrl: './my-vehicle-select.component.css',
})
export class MyVehicleSelectComponent implements OnInit, OnChanges, OnDestroy {
  @Input() card: ParkingCardInfo | null = null;
  @Input() isOpen: boolean = false;

  @Output() close = new EventEmitter<void>();
  @Output() confirmSelection = new EventEmitter<{
    card: ParkingCardInfo;
    selectedVehicle: MyVehicleAllForChange;
  }>();

  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;

  token: string = '';
  uid: string = '';
  isLoading: boolean = false;
  myVehicle: MyVehicleAllForChange[] = [];
  selectedVehicles: MyVehicleAllForChange[] = [];

  selectedVehicle: MyVehicleAllForChange | null = null;

  constructor(
    private apiVehicleService: ApiVehicleService,
    private cookieService: CookieService,
    private languageService: LanguageService,
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit() {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen'] && this.isOpen) {
      this.selectedVehicle = null;
      if (this.card) {
        this.getMyCityVehicle();
      }
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  getMyCityVehicle() {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    const body: MyVehicleSelectPayload = {
      token: this.token,
      uid: this.uid,
      siteId: this.card?.siteId,
      cardCode: this.card?.cardCode,
      vehicleTypeId: this.card?.vehicleTypeId,
    }
    console.log('getMyCityVehicle request:', body, JSON.stringify(body, null, 2));

    if (!this.card) return;
    this.isLoading = true;
    this.apiVehicleService
      .getVehicleAllChangeMember(
        body
      )
      .subscribe({
        next: (cards: MyVehicleAllForChange[]) => {
          console.log('getMyCityVehicle API response:', cards);
          this.myVehicle = cards || [];
          this.isLoading = false;
          // Show all vehicles from API without filtering
          this.selectedVehicles = this.myVehicle;
          console.log('selectedVehicles set:', this.selectedVehicles);
        },
        error: (err) => {
          console.error('โหลดบัตรสมาชิกล้มเหลว', err);
          this.isLoading = false;
        },
      });
  }

  onSelectVehicle(v: MyVehicleAllForChange) {
    this.selectedVehicle = v;
  }

  onClose() {
    this.close.emit();
  }

  onConfirm() {
    if (this.card && this.selectedVehicle) {
      this.confirmSelection.emit({
        card: this.card,
        selectedVehicle: this.selectedVehicle,
      });
      console.log('confirmSelection', this.selectedVehicle);
    }
  }
}
